import React from "react";
import styled from "styled-components";

import { XMarkIcon } from "src/static/icons";
import { profileTagShellStyles } from "src/views/profile/components/tagShellStyles";

/**
 * Presentational empty-state chip for the Teammates section.
 * Visually aligned with ProfileTag (padding, radius, gap) but dashed to
 * communicate that no teammates have been added yet.
 */
const EmptyTeammatesPlaceholder: React.FC<
  React.ComponentPropsWithoutRef<"div">
> = (props) => (
  <Tag {...props} aria-label="No teammates added">
    <Label>Add Teammate</Label>
    <CloseIcon aria-hidden />
  </Tag>
);

export default EmptyTeammatesPlaceholder;

const Tag = styled.div`
  ${profileTagShellStyles}
  border: 2px dashed ${({ theme }) => theme.globalConstants.color.textTertiary};
  background: transparent;
  color: ${({ theme }) => theme.globalConstants.color.textSecondary};
`;

const Label = styled.span`
  font-family: ${({ theme }) => theme.globalConstants.fontFamily.body};
  font-weight: 400;
  font-size: 16px;
  line-height: 1.6em;
  letter-spacing: 0;
  color: ${({ theme }) => theme.globalConstants.color.textSecondary};
`;

const CloseIcon = styled(XMarkIcon)`
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  color: ${({ theme }) => theme.globalConstants.color.textTertiary};

  path {
    stroke: currentColor;
  }
`;
